// src/config.js
const config = {
    API_BASE_URL: 'https://safenest-backend-f9290b6b0ce3.herokuapp.com/', // Replace with your actual Heroku app URL
  };
  
  export default config;
  